// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oXFv","top":"styles_top__11qLo","left":"styles_left__35zDL","description":"styles_description__bexY5"};